import React from 'react';
import truncate from 'lodash.truncate';
import _escapeRegex from 'utils/regEx';

export const TruncatedSearchResult = ({ result, term }) => {
  const toTruncate = result.title || result.name;

  let truncated = truncate(toTruncate, 40);
  const termFoundIndex = truncated.toLowerCase().indexOf(term.toLowerCase());

  if (termFoundIndex !== -1) {
    const escapedTerm = _escapeRegex(term);
    const re = new RegExp(escapedTerm, 'i');
    const match = re.exec(truncated);
    truncated = truncated.replace(match[0], '');
    var p1 = truncated.slice(0, match.index);
    var p2 = truncated.slice(match.index);
    return (
      <span>
        {p1}
        <strong>{match[0]}</strong>
        {p2}
      </span>
    );
  }
};
